import { LoadingButton } from "@mui/lab";
import { Box } from "@mui/material";
import React from "react";
import SaveIcon from "@mui/icons-material/Save";
const SaveButton = ({ loading, onClick }) => {
  const handleClick = () => {
    if (onClick) {
      onClick();
    }
  };
  return (
    <Box my={2} display={"flex"} justifyContent={"end"}>
      <LoadingButton
        type="submit"
        loading={loading}
        onClick={handleClick}
        variant="contained"
        size="small"
        startIcon={<SaveIcon />}
      >
        Save
      </LoadingButton>
    </Box>
  );
};

export default SaveButton;
